import { cn } from '@/lib/utils';
import { useNavigation, useVisibleTabs } from './navigation';
import { TAB_META } from './navIcons';

/** Mobile navigation, "Aktuell" first. One tab fewer for a view-only account. */
export function Bottombar() {
  const { setTab } = useNavigation();
  const { tabs, activeTab } = useVisibleTabs();

  return (
    <nav
      aria-label="Hauptnavigation"
      className="shrink-0 border-t border-line bg-card"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex px-1 pt-1.5 pb-2.5">
        {tabs.map((value) => {
          const { label, Icon } = TAB_META[value];
          const active = value === activeTab;
          return (
            <button
              key={value}
              type="button"
              aria-current={active ? 'page' : undefined}
              onClick={() => setTab(value)}
              className="flex flex-1 flex-col items-center gap-[3px] py-1"
            >
              <Icon
                className={cn('size-5', active ? 'text-fg' : 'text-fg-hint')}
                strokeWidth={active ? 2.2 : 2}
              />
              <span
                className={cn(
                  'text-tab',
                  active ? 'font-semibold text-fg' : 'font-medium text-fg-hint',
                )}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
